import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";

$.fn.attachHoverStatus = function attachHoverStatus(decayTime) {
	$.data(this.get(0), {
		hoverDecayTime: u_.isInteger(decayTime) ? decayTime : 0
	});
	
	this
	.on("mouseenter touchstart", "a, .hover-target", e => {
		$(e.currentTarget).addClass("is-hover");
	})
	.on("mouseleave touchend", "a, .hover-target", e => {
		const hoverDecayTime = $.data(e.delegateTarget, "hoverDecayTime");
		setTimeout($.fn.removeClass.bind($(e.currentTarget), "is-hover"), hoverDecayTime);
	});
	
	return this;
};
